export default __webpack_public_path__ + "static/ratecity-2020-7bd7012a99a404ca99650575382f5856.svg";